"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withStyles = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var context_1 = require("./context");
var hoist_non_react_statics_1 = (0, tslib_1.__importDefault)(require("hoist-non-react-statics"));
var utils_1 = require("./utils");
var withStyles = function (stylesModule) { return function (Comp) {
    if (!(0, utils_1.isStyleModule)(stylesModule)) {
        return Comp;
    }
    var StylesWrap = /** @class */ (function (_super) {
        (0, tslib_1.__extends)(StylesWrap, _super);
        function StylesWrap(props, context) {
            var _this = _super.call(this, props) || this;
            _this.cleanCss = context.insertCss(stylesModule);
            return _this;
        }
        StylesWrap.prototype.componentWillUnmount = function () {
            var _this = this;
            setTimeout(function () {
                _this.cleanCss();
            }, 0);
        };
        StylesWrap.prototype.render = function () {
            return react_1.default.createElement(Comp, (0, tslib_1.__assign)({}, this.props));
        };
        StylesWrap.contextType = context_1.StylesParamsContext;
        return StylesWrap;
    }(react_1.default.Component));
    return (0, hoist_non_react_statics_1.default)(StylesWrap, Comp);
}; };
exports.withStyles = withStyles;
//# sourceMappingURL=withStyles.js.map